import { memo, useCallback } from 'react';
import styled from 'styled-components';
import SelectionCheckbox from './BulkActions/components/SelectionCheckbox';
import { useBoardSelector } from './BulkActions/redux/reduxHooks';
import { getSomeSelected } from './BulkActions/redux/selectionSlice';
import { useConfigs } from './lib/config-context';
import { Clickable } from 'foundations-components/transitional/components/Clickable';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledTileWrapper = styled.div.withConfig({
  displayName: "CardContent__StyledTileWrapper",
  componentId: "sc-1nuhc98-0"
})(({
  theme
}) => `
  background-color: ${theme.color['fill-surface-default']};
  line-height: 20px;
  word-break: break-word;

  &[data-shaded="true"] {
    background-color: ${theme.color['fill-accent-neutral-subtle-alt']};

  }
  &:hover {
    background-color: ${theme.color['fill-surface-recessed']};
  }
`);
const CardContent = ({
  cardData,
  columnData
}) => {
  const {
    CardComponent,
    getIsCardShaded,
    onCardClick,
    StyledCardComponent
  } = useConfigs();
  const onClick = useCallback(() => typeof onCardClick === 'function' && onCardClick(cardData.data), [cardData.data, onCardClick]);
  const showBulkActions = useBoardSelector(getSomeSelected);

  // Render provided styled card component if available
  if (StyledCardComponent) {
    return /*#__PURE__*/_jsx(StyledCardComponent, {
      data: cardData.data,
      hasSelectionCheckbox: showBulkActions,
      SelectionCheckbox: SelectionCheckbox
    });
  }
  const isShaded = getIsCardShaded ? getIsCardShaded(cardData, columnData) : false;
  return /*#__PURE__*/_jsx(Clickable, {
    disabled: !onCardClick,
    onClick: onClick,
    children: /*#__PURE__*/_jsx(StyledTileWrapper, {
      "data-test-id": "cdb-card",
      "data-shaded": isShaded,
      children: /*#__PURE__*/_jsx(View, {
        position: "relative",
        borderRadius: "100",
        paddingBlockEnd: "100",
        paddingBlockStart: "200",
        paddingInline: "300",
        borderWidth: "100",
        borderColor: `${isShaded ? 'border-core-default' : 'border-core-subtle'}`,
        borderStyle: "solid",
        children: /*#__PURE__*/_jsx(CardComponent, {
          SelectionCheckbox: SelectionCheckbox,
          data: cardData.data,
          boardBulkActionsVisible: showBulkActions
        })
      })
    })
  });
};
export default /*#__PURE__*/memo(CardContent);